import React from "react";
import { apiClient } from "@/lib/apiClient";
import { toast } from "sonner";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { DocumentViewer } from "@/components/inbox/DocumentViewer";

export function ReceiptZoomDialog({ receipt, blobUrl, onClose, onNoteSaved }) {
  return (
    <Dialog open={!!receipt} onOpenChange={(open) => !open && onClose()}>
      <DialogContent className="max-w-[92vw] xl:max-w-6xl max-h-[94vh]" data-testid="receipt-zoom-dialog">
        <DialogHeader>
          <DialogTitle>
            Beleg-Vorschau
            {receipt?.merchant_name_ai && (
              <span className="ml-2 text-sm font-normal text-slate-500">
                · {receipt.merchant_name_ai}
              </span>
            )}
          </DialogTitle>
        </DialogHeader>
        <div className="h-[64vh] rounded-md border border-slate-200 overflow-hidden flex bg-slate-100">
          {blobUrl ? (
            <DocumentViewer blobUrl={blobUrl} contentType={receipt?.mime_type || "application/pdf"} fileName={receipt?.file_name || "Beleg"} />
          ) : (
            <div className="m-auto text-sm text-slate-500">Lade Beleg…</div>
          )}
        </div>
        {receipt && (
          <div className="pt-3 border-t border-slate-100">
            <label className="text-xs font-medium text-slate-600 flex items-center gap-1 mb-1">
              📝 Notiz vom Uploader / Buchhalter
            </label>
            <textarea
              data-testid="receipt-zoom-user-note-input"
              defaultValue={receipt.user_note || ""}
              placeholder="z.B. Kundenessen mit XY, Auftrag #4271, Projekt Alpha…"
              className="w-full text-sm border border-slate-300 rounded-md px-2 py-1.5 min-h-[60px]"
              onBlur={async (e) => {
                const val = e.target.value.trim();
                if (val === (receipt.user_note || "")) return;
                try {
                  await apiClient.put(`/receipts/${receipt._id}`, {
                    user_note: val || null,
                  });
                  toast.success("Notiz gespeichert");
                  onNoteSaved?.();
                } catch (err) {
                  toast.error("Notiz konnte nicht gespeichert werden");
                }
              }}
            />
            <div className="text-[10px] text-slate-500 mt-1">
              Wird automatisch beim Verlassen des Feldes gespeichert. Bei
              WhatsApp-Uploads kannst du auch direkt eine Bildunterschrift
              mitschicken — die wird hier gespeichert.
            </div>
          </div>
        )}
        <div className="flex items-center justify-between pt-2 text-xs text-slate-500">
          <span>
            {receipt?.original_filename ||
              receipt?.file_path?.split("/").pop() ||
              "Beleg"}
          </span>
          {blobUrl && (
            <a
              href={blobUrl}
              download={receipt?.original_filename || "beleg"}
              className="text-violet-700 hover:underline"
              data-testid="receipt-zoom-download"
            >
              Original herunterladen
            </a>
          )}
        </div>
      </DialogContent>
    </Dialog>
  );
}
